export default __webpack_public_path__ + "static/media/Design.158b35aa.svg";